
























import { Component, Prop, Vue } from "vue-property-decorator";
import DeferredAutocomplete, {
  DefferedAutocompleteItem,
} from "./DeferredAutocomplete.vue";
import _ from "lodash";

export type DefferedAutocompleteFetcherFn = (
  val: { id: number } | { search: string }
) => Promise<DefferedAutocompleteItem[]>;

@Component({
  components: {
    DeferredAutocomplete,
  },
})
export default class DeferredAutocompleteWrapper extends Vue {
  @Prop() readonly value?: number;
  @Prop() label?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop() fetch?: DefferedAutocompleteFetcherFn;
  @Prop() readonly?: boolean;
  @Prop() rules?: ((v: any) => boolean)[];
  @Prop({ default: false }) clearable?: boolean;

  @Prop({ default: false }) outlined?: boolean;
  @Prop({ default: false }) dense?: boolean;
  @Prop({ default: false }) hideDetails?: boolean;

  isLoading = false;
  items: DefferedAutocompleteItem[] = [];

  defferedAutocomplete = _.debounce(this.autocomplete, 300);
  autocomplete(val: { id: number } | { search: string }) {
    if (!this.fetch) return;
    this.isLoading = true;
    this.fetch(val).then((res) => {
      if (!res.some((x) => x.id === this.value)) {
        res = res.concat(this.items.filter((x) => x.id === this.value));
      }
      this.items = res;
      this.isLoading = false;
    });
  }
}
